






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

interface Insertion {
    proofReceptionDate: string;
}

@Component({ components: { } })
export default class ProofsDate extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.proofReceptionDate",
        ];
    }
}
